import React, { Fragment } from "react";
import { MemoryRouter, Route } from "react-router";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
import { cartAdd } from "../../actions/cart";
import { Button, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import StarRatings from "react-star-ratings";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getProductsByCategoryId } from "../../actions/products";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {
  childCategories,
  subCategories,
  getProducts,
  getBanners,
  getChildCategoryBySlug,
} from "../../actions/categories";
import {
  CarouselProvider,
  DotGroup,
  ImageWithZoom,
  Slide,
  Slider,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataPerPage: 40,
      currentPage: 1,
      loading: true,
      childCategory: null,
      subCategories: null,
      products: null,
      show: false,
      quickView: [],
      images: [],
      quantity: 1,
      affirm: [],
    };
  }

  fetchData = async (slug) => {
    // const res = await this.props.childCategories();
    // const _res = await this.props.subCategories();
    // const __res = await this.props.getProducts();
    const res = await this.props.getChildCategoryBySlug(slug);

    this.setState({ childCategory: res && res.data && res.data[0] });

    const products = [];
    res &&
      res.data[0].subcategories.forEach(async (element) => {
        const product = await this.props.getProductsByCategoryId(element._id);

        if (product.length > 0) {
          // console.log("categoryid", element._id, "product", product);
          // products.push(product[0]);
          Array.prototype.push.apply(products, product);
        }

        this.setState({
          subCategories: res && res.data[0].subcategories,
          loading: false,
          products: products,
        });
      });
  };

  async componentDidMount() {
    const slug = window.location.toString().split("y/")[1];
    window.scrollTo(0, 0);
    this.fetchData(slug);
  }

  componentWillReceiveProps() {
    if (
      this.props.match.params.slug !== window.location.toString().split("y/")[1]
    ) {
      window.scrollTo(0, 0);
      this.fetchData();
    }
  }

  handleClick = (event) => {
    this.setState({
      currentPage: Number(event.page),
    });
  };
  _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "B" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      this.setState({ show: false });
      toast(`Product added to wishlist`, { containerId: "B" });
    }
  };

  _addToCart = async (item) => {
    const data = {
      item: item,
      quantity: this.state.quantity,
    };
    const cartAdd = await this.props.cartAdd(data);
    if (cartAdd) {
      this.setState({
        show: false,
        quantity: 1,
      });
      toast(`Product added in cart`, { containerId: "B" });
    }
  };
  handleClose = () => {
    this.setState({ show: false, quantity: 1 });
  };
  handleShow = () => {
    this.setState({ show: true, quantity: 1 });
  };
  _openModal = async (e, item) => {
    e.preventDefault();

    await this.setState({ quickView: item });
    const images = [];
    item.images.forEach((e) => {
      images.push({
        original: e,
        thumbnail: e,
      });
    });
    this.setState({ images: images });

    this.setState({ show: true });
  };
  render() {
    const {
      loading,
      childCategory,
      subCategories,
      quickView,
      images,
    } = this.state;
    const { products, currentPage, dataPerPage, affirm } = this.state;

    // Logic for displaying todos
    const indexOfLastTodo = currentPage * dataPerPage;
    const indexOfFirstTodo = indexOfLastTodo - dataPerPage;
    const currentTodos =
      products && products.slice(indexOfFirstTodo, indexOfLastTodo);

    const renderTodos =
      currentTodos &&
      currentTodos.length > 0 &&
      currentTodos.map((item, index) => {
        return (
          <div
            key={index}
            className="col-md-3 my-3 col-sm-6 col-12 borderBottom-1"
          >
            <Link to={`/product/${item.slug}`}>
              <div className="product-cards">
                <div className="product-cards-img">
                  <img src={`${item.images[0]}`} width="100%" alt="" />
                </div>
                <div className="card-inner-area">
                  <span className="sale-sticker">Sale</span>
                  <span
                    className="sale-wish"
                    onClick={(e) => {
                      e.preventDefault();
                      this._addToWishlist(item && item);
                    }}
                  >
                    <i className="far fa-heart" />
                  </span>
                  <div className="quick-view-btn">
                    <a href="" onClick={(e) => this._openModal(e, item)}>
                      <span>Quickview</span>
                    </a>
                  </div>
                </div>
                <div className="product-cards-content">
                  <div className="product-cards-txt">
                    <div className="row">
                      {item.grouping &&
                        item.grouping.length > 0 &&
                        item.grouping.map((group, indx) => (
                          <div className="col-md-2 col-sm-2 col-2" key={indx}>
                            <Link
                              className="text-color"
                              to={`/product/${group.slug}`}
                            >
                              <img
                                src={group && group.images[0]}
                                alt={group && group.title}
                                style={{
                                  border: "1px solid gray",
                                  borderRadius: "7px",
                                  width: "100%",
                                  marginTop: "4px",
                                }}
                              />
                            </Link>
                          </div>
                        ))}
                    </div>
                    <h6
                      className="text-color"
                      onClick={() => {
                        this.props.history.push(`/product/${item.slug}`);
                      }}
                    >
                      {item && item.title}
                    </h6>
                    <div className="product-cards-price">
                      <span>
                        $
                        {item.enableSale === true
                          ? Number(
                              item.price -
                                (item.price * item.saleDiscount) / 100
                            ).toFixed(2)
                          : Number(item.price).toFixed(2)}
                      </span>
                      <span>
                        {item.enableSale === true ? (
                          <del>${Number(item.price).toFixed(2)}</del>
                        ) : null}
                      </span>
                    </div>
                    <div className="product-cards-rating">
                      <ul className="product-rating">
                        <StarRatings
                          rating={
                            item.reviews ? item.reviews / item.reviewCount : 0
                          }
                          starDimension="20px"
                          starSpacing="2px"
                          starRatedColor="gold"
                        />
                        <span className="text-color">{item.reviewCount}</span>
                      </ul>
                      <span className="affirm-text ">
                        {" "}
                        <p
                          className="affirm-as-low-as"
                          data-page-type="category"
                          data-amount={`${item && item.price * 100}`}
                        ></p>
                      </span>
                      <span className="text-color">
                        {item.price > 49 ? <b>Free Shipping</b> : <b></b>}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      });

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(products && products.length / dataPerPage);
      i++
    ) {
      pageNumbers.push(i);
    }

    // const renderPageNumbers = pageNumbers.map((number) => {
    //   return (
    //     <ul style={{ display: "inline-block" }}>
    //       <li
    //         className={number === this.state.currentPage ? "active" : ""}
    //         key={number}
    //         id={number}
    //         style={{ listStyle: "none" }}
    //       >
    //         {/* {number === this.state.currentPage ? ( */}
    //         <button
    //           id={number}
    //           className="btn btn-primary pagi-button"
    //           onClick={this.handleClick}
    //         >
    //           {number}
    //         </button>
    //       </li>
    //     </ul>
    //   );
    // });

    return (
      <Fragment>
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />
        <div
          className="container-fluid py-3 wrapper-90 max-1600"
          style={{ backgroundColor: "#f4f4f5", borderRadius: "10px" }}
          id="categorie-Appliance-slider"
        >
          <Breadcrumb title={childCategory && childCategory.name} />
          <OwlCarousel
            className="owl-theme fiveCategScreen-owlCarousel"
            loop
            items={7}
            margin={10}
            nav
            responsiveClass={true}
          >
            {subCategories &&
              subCategories.length > 0 &&
              subCategories.map((_item, _index) => (
                <div className="item">
                  <img
                    src={_item.image}
                    alt={_item.name}
                    width="100%"
                    onClick={() => {
                      this.props.history.push(`/products/${_item.slug}`);
                    }}
                  />

                  <Link
                    className="categoriy-img-link"
                    to={`/products/${_item.slug}`}
                  >
                    {_item.name}
                  </Link>
                </div>
              ))}
          </OwlCarousel>
          <OwlCarousel
            className="owl-theme fourCategScreen-owlCarousel"
            loop
            items={5}
            margin={10}
            nav
            responsiveClass={true}
          >
            {subCategories &&
              subCategories.length > 0 &&
              subCategories.map((_item, _index) => (
                <div className="item">
                  <img
                    src={_item.image}
                    alt={_item.name}
                    width="100%"
                    onClick={() => {
                      this.props.history.push(`/products/${_item.slug}`);
                    }}
                  />

                  <Link
                    className="categoriy-img-link"
                    to={`/products/${_item.slug}`}
                  >
                    {_item.name}
                  </Link>
                </div>
              ))}
          </OwlCarousel>
          <OwlCarousel
            className="owl-theme threeCategScreen-owlCarousel"
            loop
            items={4}
            margin={10}
            nav
            responsiveClass={true}
          >
            {subCategories &&
              subCategories.length > 0 &&
              subCategories.map((_item, _index) => (
                <div className="item">
                  <img
                    src={_item.image}
                    alt={_item.name}
                    width="100%"
                    onClick={() => {
                      this.props.history.push(`/products/${_item.slug}`);
                    }}
                  />

                  <Link
                    className="categoriy-img-link"
                    to={`/products/${_item.slug}`}
                  >
                    {_item.name}
                  </Link>
                </div>
              ))}
          </OwlCarousel>
          <OwlCarousel
            className="owl-theme twoCategScreen-owlCarousel"
            loop
            items={2}
            margin={10}
            nav
            responsiveClass={true}
          >
            {subCategories &&
              subCategories.length > 0 &&
              subCategories.map((_item, _index) => (
                <div className="item">
                  <img
                    src={_item.image}
                    alt={_item.name}
                    width="100%"
                    onClick={() => {
                      this.props.history.push(`/products/${_item.slug}`);
                    }}
                  />

                  <Link
                    className="categoriy-img-link"
                    to={`/products/${_item.slug}`}
                  >
                    {_item.name}
                  </Link>
                </div>
              ))}
          </OwlCarousel>
        </div>
        <hr />
        <div className="products-page wrapper-90 max-1600">
          <div className="products-body">
            <div className="container-fluid">
              <div className="products-items">
                {/* FIRST ROW */}
                <div className="row">{renderTodos}</div>
                <div className="container text-center ">
                  {" "}
                  <MemoryRouter initialEntries={["/inbox"]} initialIndex={0}>
                    <Route>
                      {({ location }) => {
                        return (
                          <Pagination
                            page={
                              this.state.currentPage && this.state.currentPage
                            }
                            count={pageNumbers && pageNumbers.length}
                            renderItem={(item) => (
                              <PaginationItem
                                {...item}
                                onClick={(e) => this.handleClick(item)}
                              />
                            )}
                          />
                        );
                      }}
                    </Route>
                  </MemoryRouter>
                </div>
                {/*product item row*/}
                {/* END FIRST ROW */}
              </div>
              {/*product item*/}
            </div>
            {/*Container fluid*/}
          </div>
          {/*product body*/}
        </div>
        <div ref={(el) => (this.instance = el)}></div>
        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          animation={false}
          style={{ marginTop: "2%", boxShadow: "none" }}
        >
          <Modal.Body>
            {this.state.show && this.state.show === true && quickView ? (
              <div className="container-fluid">
                <div className="row">
                  <div
                    className="modal-close"
                    onClick={this.handleClose}
                    data-dismiss="modal"
                  >
                    <span closeButton>×</span>
                  </div>
                  <div className="col-md-6">
                    <div className="modal-left-side">
                      <div className="moda-left-heading">
                        <h2>{quickView && quickView.title}</h2>
                      </div>
                      <div className="modal-seemore">
                        See More from
                        <a href="#">{this.state.brand && this.state.brand}</a>
                        Shop
                      </div>
                      <div className="modal-reviews">
                        <ul id="modal-stars">
                          <StarRatings
                            rating={
                              quickView && quickView.reviews
                                ? quickView.reviews / quickView.reviewCount
                                : 0
                            }
                            starDimension="20px"
                            starSpacing="2px"
                            starRatedColor="gold"
                          />
                          <span>{quickView && quickView.reviewCount}</span>
                        </ul>
                      </div>
                      <div className="modal-slider">
                        <CarouselProvider
                          visibleSlides={1}
                          totalSlides={quickView && quickView.images.length}
                          step={1}
                          naturalSlideWidth={400}
                          naturalSlideHeight={400}
                          hasMasterSpinner
                        >
                          <Slider>
                            {quickView &&
                              quickView.images &&
                              quickView.images.map((item, index) => (
                                <Slide index={index}>
                                  <ImageWithZoom src={item} />
                                </Slide>
                              ))}
                          </Slider>

                          <DotGroup />
                        </CarouselProvider>
                      </div>
                    </div>{" "}
                    {/*END MODAL LEFT SIDE*/}
                  </div>
                  <div
                    className="col-md-6"
                    style={{ backgroundColor: "hsla(240,5%,96%,.85)" }}
                  >
                    <div className="moda-right-side">
                      <div className="modal-right-price">
                        <span className="m-price">
                          $
                          {quickView.enableSale === true
                            ? Number(
                                quickView.price -
                                  (quickView.price * quickView.saleDiscount) /
                                    100
                              ).toFixed(2) * this.state.quantity
                            : Number(quickView.price).toFixed(2) *
                              this.state.quantity}
                        </span>
                        <span>
                          {quickView.enableSale === true ? (
                            <del className="moda-right-price-off">
                              ${Number(quickView.price).toFixed(2)}
                            </del>
                          ) : null}
                        </span>
                      </div>
                      <div className="modal-shiping-dete">
                        <span>FREE Shipping</span>
                        <span>Get it Now</span>
                      </div>

                      <div className="modal-right-collapse">
                        <div className="accordion" id="accordion">
                          <div className="card mt-3">
                            <div className="checkout-inps">
                              <span className="selectcountry-hint">
                                Select Quantity
                              </span>
                              <select
                                className="countrySelect"
                                onChange={(e) => {
                                  this.setState({
                                    quantity: e.target.value,
                                  });
                                }}
                              >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-description"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#description-collapse"
                                aria-expanded="false"
                                aria-controls="description-collapse"
                              >
                                Description
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="description-collapse"
                              className="collapse"
                              aria-labelledby="product1description"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="description-body">
                                  <div className="description-content">
                                    <p>{quickView && quickView.description}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-weights-dimention"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#weights-dimention-collapse"
                                aria-expanded="false"
                                aria-controls="weights-dimention-collapse"
                              >
                                Weights & Dimensions
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="weights-dimention-collapse"
                              className="collapse"
                              aria-labelledby="product1weights-dimention"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="weights-dimension-content">
                                  {quickView &&
                                    quickView.weightAndDimension &&
                                    quickView.weightAndDimension.weightAndDimension.map(
                                      (e, index) => (
                                        <Fragment key={index}>
                                          {JSON.parse(e).value &&
                                          JSON.parse(e).value !== "" ? (
                                            <Fragment>
                                              <p className="dimension-heading">
                                                {JSON.parse(e).name}
                                              </p>
                                              <div className="product-weight">
                                                <div className="overall-weight">
                                                  <p className="m-0 py-2">
                                                    {JSON.parse(e).name}
                                                  </p>
                                                </div>
                                                <p className="m-0 py-2">
                                                  {JSON.parse(e).value}
                                                </p>
                                              </div>
                                            </Fragment>
                                          ) : null}
                                        </Fragment>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-spesification"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#spesification-collapse"
                                aria-expanded="false"
                                aria-controls="spesification-collapse"
                              >
                                Specifications
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="spesification-collapse"
                              className="collapse"
                              aria-labelledby="product1spesification"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="spesification-content">
                                  {quickView &&
                                    quickView.specification &&
                                    quickView.specification.specification.map(
                                      (e, index) => (
                                        <div
                                          key={index}
                                          className="product-weight"
                                        >
                                          {" "}
                                          {JSON.parse(e).value &&
                                          JSON.parse(e).value !== "" ? (
                                            <Fragment>
                                              <div className="overall-weight">
                                                <p className="m-0 py-2">
                                                  {JSON.parse(e).name}
                                                </p>
                                              </div>
                                              <p className="m-0 py-2">
                                                {JSON.parse(e).value}
                                              </p>
                                            </Fragment>
                                          ) : null}
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="modal-end-btns">
                            <button
                              type="button"
                              className="modal-add-cart"
                              onClick={(e) => {
                                e.preventDefault();
                                this._addToCart(quickView && quickView);
                              }}
                            >
                              <span>Add To Cart</span>
                            </button>
                            <button
                              type="button"
                              className="modal-save-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                this._addToWishlist(quickView && quickView);
                              }}
                            >
                              <span>
                                <i className="far fa-heart" /> Save
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              "<div></div>"
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}
childCategories.propTypes = {
  childCategories: PropTypes.func.isRequired,
};
subCategories.propTypes = {
  subCategories: PropTypes.func.isRequired,
};
getChildCategoryBySlug.propTypes = {
  getChildCategoryBySlug: PropTypes.func.isRequired,
};
getProducts.propTypes = {
  getProducts: PropTypes.func.isRequired,
};
getProductsByCategoryId.propTypes = {
  getProductsByCategoryId: PropTypes.func.isRequired,
};
getBanners.propTypes = {
  getBanners: PropTypes.func.isRequired,
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};

export default withRouter(
  connect(null, {
    childCategories,
    subCategories,
    getProducts,
    getBanners,
    cartAdd,
    getProductsByCategoryId,
    getChildCategoryBySlug,
  })(Index)
);
